import { SipClientStatus } from '../../../services/SipClientService/enums';
import ModalComponent from '../../../components/ModalComponent';
import React, { useContext } from 'react';
import CallRender from './CallRender';
import { AppContext } from '../../../context/AppContextProvider';
import { Box } from '@mui/material';

const CallRenderModal = () => {
  const { sipClientStatusDetails } = useContext(AppContext);

  const closedModal =
    !sipClientStatusDetails.status ||
    sipClientStatusDetails.status === SipClientStatus.NO_ACTIVITY;

  if (closedModal) return <></>;

  return (
    <ModalComponent width={'auto'} onClose={() => {}} isOpen>
      <Box margin={4}>
        <CallRender />
      </Box>
    </ModalComponent>
  );
};

export default CallRenderModal;
